import React from 'react'
import * as UI from 'ui'
import { SpaceBetween } from 'ui'
import * as Displays from 'support/displays'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import {ForEachModel, ValueToCollection} from '@morningtrain/react-resources'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import {Env} from "@morningtrain/helpers";

export default function AvgBasketSizeSummaryWidget ({ className }) {
  const hasMultipleTakeaway = Env.get('globals.has_multiple_takeaway');
  const takeaways = Env.get('globals.takeaways');

  return (
    <Widget>
      <Translator namespace='economy.pages.avg_basket_size'>
        <UI.Card paddingBottom={false} className={className}>
          <SpaceBetween>
            <UI.Text weight='medium' size='lg'>
              <Translation name='headers.basket_size_with_discounts' />
            </UI.Text>
          </SpaceBetween>

          <ValueToCollection name='entries'>

            <div className='flex flex-col flex-grow flex-shrink pt-6'>

              <UI.Text weight='medium' size='3xl'>
                <Displays.AggregateRatio
                  name='revenue_total_with_discounts'
                  outOfName='amount_total'
                  display={<Displays.Integer />}
                />
              </UI.Text>

              <SmartviewContentSeparator />

              <SmartviewTextGroup highlight highlightSize='card'>

                <SmartviewText>
                  <UI.SpaceBetween>
                    <UI.Text size='base'>
                      <Translation name='generic.without_discounts' />
                    </UI.Text>
                    <UI.Text weight='medium' size='base' align='right' color='black'>
                      <Displays.AggregateRatio
                        name='revenue_total'
                        outOfName='amount_total'
                        display={<Displays.Integer />}
                      />
                    </UI.Text>
                  </UI.SpaceBetween>
                </SmartviewText>

                <SmartviewText>
                  <UI.SpaceBetween>
                    <UI.Text size='base'>
                      <Translation name='generic.inhouse' />
                    </UI.Text>
                    <UI.Text weight='medium' size='base' align='right' color='black'>
                      <Displays.AggregateRatio
                        name='revenue_inhouse_with_discounts'
                        outOfName='amount_inhouse'
                        display={<Displays.Integer />}
                      />
                    </UI.Text>
                  </UI.SpaceBetween>
                </SmartviewText>

                {!hasMultipleTakeaway ?
                <SmartviewText>
                  <UI.SpaceBetween>
                    <UI.Text size='base'>
                      <Translation name='generic.takeaway' />
                    </UI.Text>
                    <UI.Text weight='medium' size='base' align='right' color='black'>
                      <Displays.AggregateRatio
                        name='revenue_takeaway_with_discounts'
                        outOfName='amount_takeaway'
                        display={<Displays.Integer />}
                      />
                    </UI.Text>
                  </UI.SpaceBetween>
                </SmartviewText> : false }
                  { hasMultipleTakeaway ? takeaways.map((value, i) => {
                    return (
                      <SmartviewText>
                        <UI.SpaceBetween>
                          <UI.Text size='base'>
                            {value}
                          </UI.Text>
                          <UI.Text weight='medium' size='base' align='right' color='black'>
                            <Displays.AggregateRatio
                              name={'takeaways_this_period_revenue_' + i}
                              outOfName={'takeaways_this_period_amount_' + i}
                              display={<Displays.Integer />}
                            />
                          </UI.Text>
                        </UI.SpaceBetween>
                      </SmartviewText>
                    )
                  }) : false}

              </SmartviewTextGroup>

            </div>

            <UI.HorizontalList className='my-4 pt-6 text-center' justify='center' border={false}>
              <UI.WithSubtitle
                subtitle={(
                  <UI.Text weight='medium' color='black'>
                    <Displays.Percentage
                      name='meta.last_year_change'
                      showPlusIfPositive
                      decimals={1}
                      badBelow={0}
                    />
                  </UI.Text>
                )}
              >
                <UI.Text uppercase size='xs' color='gray'>
                  <Translation name='generic.last_year' />
                </UI.Text>
              </UI.WithSubtitle>

            </UI.HorizontalList>

          </ValueToCollection>

        </UI.Card>
      </Translator>
    </Widget>
  )
}
